import { apiRequest } from "./client";

export const customersApi = {
  list(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/customers`, { params });
  },

  get(projectId, customerId) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}`);
  },

  create(projectId, payload) {
    return apiRequest(`/projects/${projectId}/customers`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateProfile(projectId, customerId, payload) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/profile`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  priceLists(projectId) {
    return apiRequest(`/projects/${projectId}/customers/price-lists`);
  },

  membershipReminders(projectId, options = {}) {
    return apiRequest(`/projects/${projectId}/customers/membership-reminders/sync`, {
      method: "POST",
      body: JSON.stringify({ limit: options.limit || 60 }),
    });
  },

  membershipItems(projectId) {
    return apiRequest(`/projects/${projectId}/customers/membership-items`);
  },

  memberships(projectId, customerId) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships`);
  },

  assignMembership(projectId, customerId, payload) {
    const operationKey = String(payload?.operationKey || "").trim();
    return apiRequest(`/projects/${projectId}/customers/${customerId}/memberships`, {
      method: "POST",
      headers: operationKey ? { "Idempotency-Key": operationKey } : undefined,
      body: JSON.stringify(payload),
    });
  },

  assignPriceList(projectId, customerId, priceListId, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/price-list`, {
      method: "PATCH",
      body: JSON.stringify({ priceListId, expectedUpdatedAt }),
    });
  },

  updateStatus(projectId, customerId, status, reason, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status, reason, expectedUpdatedAt }),
    });
  },
};
